import { isUnit, type WriteOffListRow } from '@eombor/contracts';
import { t } from '../../../shared/i18n/index.js';
import { unitText } from '../../../shared/i18n/labels.js';

const qtyText = (qty: number): string => (Math.round(qty * 1000) / 1000).toLocaleString('ru-RU');

type StockFacts = Pick<WriteOffListRow, 'status' | 'qty' | 'unit' | 'stockQtyBefore'>;

/**
 * «2 donadan 1 tasi» — buxgalter aktni ochmasdan bo'linmada nechta turgani,
 * nechtasi chiqayotgani va nechtasi qolishini ko'radi.
 *
 * Son akt YUBORILGAN paytdagi surat (`stockQtyBefore`), shuning uchun
 * tasdiqdan keyin ham «2 dan 1» bo'lib qoladi. Eski aktda surat yo'q va
 * bekor qilingan akt hech narsani chiqarmaydi — ikkalasida qator yo'q.
 */
export const stockLineText = (act: StockFacts): string | null => {
  if (act.stockQtyBefore === null || act.status === 'CANCELLED') return null;
  const unit = isUnit(act.unit) ? unitText(act.unit) : act.unit;
  const params = {
    stock: qtyText(act.stockQtyBefore),
    qty: qtyText(act.qty),
    left: qtyText(Math.max(0, act.stockQtyBefore - act.qty)),
    unit,
  };
  return act.status === 'APPROVED'
    ? t('writeOff.stockLineDone', params)
    : t('writeOff.stockLine', params);
};

export const WriteOffStockLine = ({ act, className }: { act: StockFacts; className?: string }) => {
  const text = stockLineText(act);
  return text === null ? null : <p className={className ?? 'text-xs text-text-muted'}>{text}</p>;
};
